import React from 'react'
import { Icon } from 'konsys-ui'

export const IconSelector = (id) => {
  switch (id) {
    case 1:
      return <Icon icon='far fa-user-crown' margin='0 0 16px 0' fontSize='20px'/>
    case 2:
      return <Icon icon='far fa-user-tie' margin='0 0 16px 0' fontSize='20px'/>
    case 3:
      return <Icon icon='far fa-user' margin='0 0 16px 0' fontSize='20px'/>
    case 4:
      return <Icon icon='far fa-user' margin='0 0 16px 0' fontSize='20px'/>
    default:
      return <Icon icon='far fa-user' margin='0 0 16px 0' fontSize='20px'/>
  }
}

export default IconSelector
